import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { PostSubmissionModuleName } from '@/store/modules/modules'

export class PostSubmissionViewModel {
  private store = useStore()

  judgeToken: ComputedRef<string> = computed(() => this.store.getters[`${PostSubmissionModuleName}/judgeToken`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${PostSubmissionModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${PostSubmissionModuleName}/error`])

  async postSubmission(problemId: string, programLanguage: ProgramLanguageType, sourceCode: string): Promise<void> {
    await this.store.dispatch(`${PostSubmissionModuleName}/postSubmission`, { problemId, programLanguage, sourceCode })
  }
}
